import { Component, OnInit, Injector, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ClaimModifyServiceProxy, ModifyClaimDto } from '@shared/service-proxies/service-proxies';
import { MyCommandCenterService } from '@app/main/my-command-centre/my-command-center.service';

@Component({
    selector: 'my-wearables-modal',
    templateUrl: './my-wearables-modal.component.html',
    styleUrls: ['./my-wearables-modal.component.css']
})
export class MyWearablesModalComponent extends AppComponentBase implements OnInit {
    saving = false;
    idNumber: string;
    checkTermsCondition = false;
    type: string;
    isWearables: boolean;
    @Output() onClose: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(
        private modalRef: BsModalRef,
        injector: Injector,
        private _claimModify: ClaimModifyServiceProxy,
        private _commandCenterService: MyCommandCenterService,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.isWearables = this.type === 'Wearable';
    }

    private async updateIdNumberClaim(): Promise<void> {
        let mdto = new ModifyClaimDto();
        mdto.accessToken = this._authService.user.access_token;
        mdto.newClaimType = 'id_number';
        mdto.newClaimValue = this.idNumber.toString();
        mdto.userId = this._authGuard.user.profile.sub;
        this._authGuard.user.profile.id_number = this.idNumber.toString();
        await this._claimModify.modifyClaim(mdto).toPromise();
        await this.updateClaimsIdsvr();
    }

    save() {
        this.saving = true;

        if (this._authGuard.user.profile.id_number !== this.idNumber.toString()) {
            if (this._authGuard.user.profile.id_number === '0000000000000') {
                this.updateIdNumberClaim().then(() => {
                    this.resetProps();
                    this.updateClaimsIdsvr().then(() => {
                        this.close(true);
                    });
                });
            } else {
                abp.message.warn('Your ID number does not match the one we have on record', 'Wearables activation failed', false);
                this._commandCenterService.changeTemplatePopup('OK', undefined);
                this.resetProps();
                this.close(false);

            }
        } else {
            this.resetProps();
            this.close(true);
        }
    }

    private resetProps(): void {
        this.idNumber = null;
        this.checkTermsCondition = false;
        this.saving = false;
    }

    close(success: boolean) {
        this.modalRef.hide();
        this.onClose.next(success);
    }
}
